import { useNavigate } from "react-router-dom";
import { ShieldX } from "lucide-react";
import { Button } from "@/components/ui/button";

interface AccessDeniedPopupProps {
  redirectTo?: string;
  redirectLabel?: string;
}

export const AccessDeniedPopup = ({ 
  redirectTo = "/", 
  redirectLabel = "Vissza a főoldalra" 
}: AccessDeniedPopupProps) => {
  const navigate = useNavigate();

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm">
      <div className="bg-red-600 text-white rounded-2xl shadow-2xl p-8 max-w-md mx-4 animate-in zoom-in-95 duration-300">
        <div className="flex flex-col items-center text-center">
          <div className="bg-white/20 rounded-full p-4 mb-4">
            <ShieldX className="h-16 w-16" />
          </div>
          <h1 className="text-3xl font-bold mb-2">
            Nincs jogosultságod az eléréshez!!!
          </h1>
          <p className="text-red-100 mb-6">
            A kért oldal vagy funkció nem érhető el a jelenlegi jogosultságaiddal.
          </p>
          <Button
            onClick={() => navigate(redirectTo)}
            variant="secondary"
            size="lg"
            className="bg-white text-red-600 hover:bg-red-100 font-semibold"
          >
            {redirectLabel}
          </Button>
        </div>
      </div>
    </div>
  );
};
